<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">جامعة جديدة</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-group">
            <input class="input" type="text" formControlName="university_name" placeholder="اسم الجامعة" />
          </div>

          <div class="form-group">
            <input class="input" type="number" formControlName="fees" placeholder="الرسوم" />
          </div>

          <div class="form-group">
            <button type="submit" class="fromsave accont" [disabled]="data.invalid">
              @if(isUpdatePage){
              {{ 'Edit' | translate }}

              }
              @else{
              انشاء

              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>